import { render, staticRenderFns } from "./tagView.vue?vue&type=template&id=37ff3d10&scoped=true&"
import script from "./tagView.vue?vue&type=script&lang=js&"
export * from "./tagView.vue?vue&type=script&lang=js&"
import style0 from "./tagView.vue?vue&type=style&index=0&id=37ff3d10&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ff3d10",
  null
  
)

export default component.exports